import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { ButtonProps } from 'app/core/json-schema-controls/models/button-props.model';
import { JsonSchemaService } from 'app/core/json-schema-controls/services/json-schema.service';

@Component({
  selector: 'hmt-button-type',
  standalone: true,
  imports: [MatButtonModule, CommonModule, MatIconModule],
  templateUrl: './button-type.component.html',
  styleUrl: './button-type.component.scss',
})
export class ButtonTypeComponent extends FieldType<FormlyFieldConfig<ButtonProps>> {
  constructor(private readonly jsonSchemaService: JsonSchemaService) {
    super();
  }

  get styleObject() {
    return this.jsonSchemaService.cssStringToObject(this.props?.styles || '');
  }

  onClick($event: Event) {
    if (this.props.onClick) {
      this.props.onClick($event);
    }
  }

  getStylesClasses(id: string) {
    if (this.props.disabled) {
      return 'disabled';
    }

    if (!this.props?.styleClasses || !this.props?.styleClasses[id]) {
      return '';
    }
    return this.props?.styleClasses[id];
  }
}
